import { SendOutlined } from "@ant-design/icons";
import { useSignal } from "@preact/signals-react";

import styles from "./ChatInput.module.scss";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { PublishSubscriptionStore } from "imagica-corekit/dist/cases/store/PublishSubscriptionStore";
import { getIt } from "@uikit/getIt";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";
export interface Props {
  inputText: any;
  isInput?: any;
  isLoading: boolean;
  isInCanvas: boolean;
  onSendCliked?: () => void;
  onFocusInput?: () => void;
}

export function ChatInput(props: Props) {
  const submitEnabled = useSignal<boolean>(false);
  const store = getIt(PublishSubscriptionStore);
  const state = useStore(store).value;
  const authStore = getIt(FotAuthStore);

  function sendMessage() {
    if (props.isLoading) {
      return;
    }
    if (props.onSendCliked) {
      props.onSendCliked();
    }

    props.inputText.value = "";
    submitEnabled.value = false;
  }

  function onPressEnter(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    e.preventDefault();
    //  如果是付费APP，并且没有付费
    if (state.isPaidApp && !state.isPay) {
      if (!authStore?.state?.brainToken) {
        return store.setOpenPayWallAndLogin();
      }
      return store.setIsOpenPayWall(true);
    }
    sendMessage();
  }

  function onTextAreaChanged(e: React.ChangeEvent<HTMLTextAreaElement>) {
    props.inputText.value = e.target.value;
    submitEnabled.value = e.target.value.length > 0;
    if (props.isInput) {
      props.isInput.value = true;
    }
  }

  function onTextAreaFoucs(e: React.ChangeEvent<HTMLTextAreaElement>) {
    if (props.isInput) {
      props.isInput.value = true;
    }
    if (props.onFocusInput) {
      props.onFocusInput();
    }
  }
  function onTextAreaBlur(e: React.ChangeEvent<HTMLTextAreaElement>) {
    if (props.isInput) {
      props.isInput.value = false;
    }
  }

  return (
    <div className={styles["chat-input-box"]}>
      <TextArea
        className={styles["chat-input"]}
        value={props.inputText.value}
        onChange={e => onTextAreaChanged(e)}
        onPressEnter={e => onPressEnter(e)}
        onFocus={e => onTextAreaFoucs(e)}
        onBlur={e => onTextAreaBlur(e)}
        placeholder="Send a message..."
        autoSize={{ minRows: 1, maxRows: props.isInCanvas ? 18 : 3 }}
      />
      <div className={styles["chat-send-box"]}>
        <div className={styles["chat-send"]}>
          <SendOutlined
            style={{ color: !props.isLoading && submitEnabled.value ? "#0A9DFF" : "#020C2659" }}
            onClick={() => sendMessage()}
          />
        </div>
      </div>
    </div>
  );
}
